import { render, staticRenderFns } from "./select-department.vue?vue&type=template&id=0b2be043"
import script from "./select-department.vue?vue&type=script&lang=ts"
export * from "./select-department.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports